
import React from 'react';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import sprintf from 'sprintf';
import SMAppHelper from 'components/helpers/SMAppHelper';
import ReactSlick from 'react-slick';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import OptimizedImage from 'components/shared/OptimizedImage';
import CSSTransitionGroup from 'react-addons-css-transition-group';

class SMSearchListTableRow extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      beforeFavoriteStatus: false,
      isOpenDefaultFavoriteList: false,
    };
  }

  next(e) {
    e.preventDefault();
    this.refs.slider.slickNext();
  }

  prev(e) {
    e.preventDefault();
    this.refs.slider.slickPrev();
  }

  favoriteDidSelect(e) {
    const isFavorite = $(e.currentTarget).hasClass("units-item-fav__on");
    e.preventDefault();
    if(!isFavorite) {
      this.setState({
        isOpenDefaultFavoriteList: true,
      });
      setTimeout(() => {
        this.setState({
          isOpenDefaultFavoriteList: false,
        });
      }, 2000);
    }

    if(this.props.delegate && typeof this.props.delegate.favoriteDidSelect === 'function'){
      this.props.delegate.favoriteDidSelect(this.props.room, isFavorite, this.props.rowIndex, "Room");
    }
  }

  renderRankIcon() {
    if (!this.props.hasRank) return null;
    if (this.props.rowIndex >= 10) return null;
    const className = sprintf("units-ranking__no%s units-ranking units-ranking__icon",
      this.props.rowIndex < 3 ? this.props.rowIndex + 1 : "n"
    );
    return (
      <div className={className}>
        <div className="units-ranking__icon-body">
          <span className="units-ranking__icon-number">{this.props.rowIndex + 1}</span>
        </div>
      </div>
    );
  }

  imageDidMouseEnter(e) {
    if(this.props.delegate && typeof this.props.delegate.imageDidMouseEnter === 'function'){
      this.props.delegate.imageDidMouseEnter(this.props.room);
    }
  }

  imageDidMouseLeave(e) {
    if(this.props.delegate && typeof this.props.delegate.imageDidMouseLeave === 'function'){
      this.props.delegate.imageDidMouseLeave(this.props.room);
    }
  }

  renderSlideView() {
    const room = this.props.room;
    const favClassName = room.is_favorite ? "units-item-fav__on units-item-fav__click" : "units-item-fav";
    let images = [];
    if (room.thumbnails.length > 0) {
      room.thumbnails.forEach((thumb, index)=>{
        if (!this.props.canSlide && index > 0) return;
        const imageUrl = SMFormatHelper.imageURLWithTransform(thumb.image,
                  {width: 840, height: 560, crop: 'fill', background: '#9c9c9c'});
        const key = room.id + '-' + index;
        const alt = sprintf("%s の写真%d", SMFormatHelper.roomNameWithSpace(room), index);
        const className = "units-item__image-pict is-hover cld-hidpi";
        images.push(
          <div key={key}>
            <OptimizedImage src={imageUrl} alt={alt} className={className} />
          </div>
        );
      });
    }
    else {
      images.push(
        <img key="noRoomImage" src={SMFormatHelper.imageURLWithTransform(this.props.noRoomImage)} className="units-item__image-pict is-hover cld-hidpi" />
      );
    }

    const latestUpdatedFavoriteListPopup = [];
    if (this.state.isOpenDefaultFavoriteList && Object.keys(this.props.latestUpdatedFavoriteList).length !== 0) {
      latestUpdatedFavoriteListPopup.push(
        <div key="latestUpdatedFavoriteList" className="units-item__baloon">
          <p className="units-item__baloon-text">{this.props.latestUpdatedFavoriteList.name}</p>
        </div>
      );
    }

    if (SMAppHelper.isMobile()) {
      return(
        <div className="js-image-keep-aspect units-item__image"
          onMouseEnter={this.imageDidMouseEnter.bind(this)}
          onMouseLeave={this.imageDidMouseLeave.bind(this)}>
          {this.renderRankIcon()}
          <a className="js-image-keep-aspect__image"
             target="_blank"
             href={Routes.space_room_path(room.space.username, room.uid, {search_session_id: this.props.searchSessionId})}>
              {images[0]}
          </a>
          <a href="#" onClick={this.favoriteDidSelect.bind(this)} aria-label="favorit" className={favClassName}><i className="fa fa-heart"></i></a>
          {SMFormatHelper.renderRoomPriceText(room, 'default', this.props.queries)}
        </div>
      );
    } else {
      const arrowStyle = !this.props.canSlide ? {display: "none"} : {};
      const slickOptions = {
        infinite: true,
        arrows: false,
        lazyLoad: true,
        fade: true,
        speed: 0,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        accessibility: false,
      };
      return(
        <div className="js-image-keep-aspect units-item__image"
          onMouseEnter={this.imageDidMouseEnter.bind(this)}
          onMouseLeave={this.imageDidMouseLeave.bind(this)}>
          {this.renderRankIcon()}
          <a className="js-image-keep-aspect__image"
             target="_blank"
             href={Routes.space_room_path(room.space.username, room.uid, {search_session_id: this.props.searchSessionId})}>
            <ReactSlick ref="slider" {...slickOptions}>
              {images}
            </ReactSlick>
          </a>
          <a href="#" style={arrowStyle} onClick={this.prev.bind(this)} aria-label="previous" className="units-item__image-prev is-hover"><i className="fa fa-chevron-left"></i></a>
          <a href="#" style={arrowStyle} onClick={this.next.bind(this)} aria-label="next" className="units-item__image-next is-hover"><i className="fa fa-chevron-right"></i></a>
          <a href="#" onClick={this.favoriteDidSelect.bind(this)} aria-label="favorit" className={favClassName}><i className="fa fa-heart"></i></a>
          <CSSTransitionGroup transitionName="js-favoritelist-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
            {latestUpdatedFavoriteListPopup}
          </CSSTransitionGroup>
          {SMFormatHelper.renderRoomPriceText(room, 'default', this.props.queries)}
        </div>
      );
    }
  }

  render() {

    const style =  {};
    const room = this.props.room;
    const options = this.props.options || {};
    const className = options.className || "col-xs-12 col-md-6 units-item";
    const id = this.props.room.id;

    return(
      <li key={id} className={className} style={style}>
        {this.renderSlideView()}
        <div className="units-item__body">
          <div className="units-item__body-inner link__subcolor">
            <h2 className="units-item__body-title js-line-camp-2"><a target="_blank" href={Routes.space_room_path(room.space.username, room.uid, {search_session_id: this.props.searchSessionId})}>{SMFormatHelper.roomName(room)}</a></h2>
            <ul className="units-item__body-info">
              <li><i className="fa fa-user mr5"></i><a target="_blank" href={Routes.search_index_path({capacity: room.capacity})}>{SMFormatHelper.capacity(room)}</a></li>
              <li><i className="fa fa-map-marker mr5"></i><a target="_blank" href={`/areas/${room.space.state}/location/${room.space.city}`}>{room.space.state_text}{room.space.city}</a></li>
              <li>
                <a target="_blank" href={Routes.reputations_space_room_path(room.space.username, room.uid)}>{SMRenderHelper.renderReviewStars(room.reputation_score)}</a>
                <a target="_blank" href={Routes.reputations_space_room_path(room.space.username, room.uid)}>{room.reputation_count}件</a>
              </li>
            </ul>
          </div>
          <p className="units-item__body-access js-line-camp-1">{room.space.access}</p>
        </div>
      </li>
    );
  }
}

export default SMSearchListTableRow;



// WEBPACK FOOTER //
// ./app/javascript/components/search/SMSearchListTableRow.jsx